import { Button, Tooltip } from 'src/components/atoms';
import styled from 'styled-components';

export const StyledTooltip = styled(Tooltip)`
  * {
    box-sizing: border-box;
  }
`;

export const StyledButton = styled(Button)<{ clicked?: boolean }>`
  ${(props) =>
    props.clicked &&
    `background-color: ${props.theme.atlas.semantic.color.action.secondary.hoverFill}!important;`}
`;

export const ButtonAndTooltipContainer = styled.div`
  width: fit-content;
`;
